// @flow

import React from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import Toggler from '../UI/Toggler';
import DropdownElements from './DropdownElements';


type Props = {
  location: Object,
};

const FLIGHT_LINK = [
  {
    title: 'Kathmandu to Lukla',
    url: '/flights',
  },
  {
    title: 'Ramechhap to Lukla',
    url: '/flights/ramechhap-to-lukla-online-flight-booking',
  },
  {
    title: 'Pokhara to Jomsom',
    url: '/flights/pokhara-to-jomsom-online-flight-booking',
  },
];

function FlightsDropdown({ location, homepage }: Props) {
  return (
    <Toggler>
      {({ on, toggle }) => (
        <Dropdown nav isOpen={on} toggle={toggle}>
          <DropdownToggle nav caret color="none" className="btn-nav-bar active">
            <span>Flights</span>
            <div className={homepage ? 'd-none' : 'd-block d-lg-none mobile-icon'}>
              <img src="https://s3.amazonaws.com/honeyguide/assets/icons/flight.svg" alt="" />
              <p>Flights</p>
            </div>
          </DropdownToggle>
          <DropdownMenu className="setting-dp">
            {
              FLIGHT_LINK.map(({ title, url }) => (
                <DropdownElements
                  key={title}
                  link={url}
                  title={title}
                  isElementVisible
                  location={location}
                />
              ))
            }
          </DropdownMenu>
        </Dropdown>
      )}
    </Toggler>
  );
}

export default withRouter(FlightsDropdown);



// WEBPACK FOOTER //
// ./src/components/TopBar/FlightsDropdown.js